/**
 * SDK配置
 */
const SdkCfg = {
    /** debug 为 true 时会输出 sdk log */
    DEBUG: true,
    /** 服务器地址 */
    SERVER_ADDRESS: 'https://sdkserver.xiaojing.work'
    // SERVER_ADDRESS: 'http://localhost:30004'
}

/** API路径 */
const APIPath = {
    /** 登录SDK服务器 上报登录 */
    LOGIN: '/api/login',
    /** 上报观看完激励视频 */
    REPORT_REWARD_VIDEO: '/api/video'
}

/** 回调选项 */
interface CallbackOptions {
    success?: () => void
    fail?: () => void
}

/** post 方法参数 */
interface PostOptions {
    apiPath: string
    body: any
    success?: (res: any) => void
    fail?: (res: PostFailRes) => void
}

interface PostFailRes {
    errMsg: string
}

/**
 * 小竞SDK
 * @desc 只有 init 和 reportRV 两静态个方法
 * 
 * @example
 * // 在游戏启动时调用 init 方法 获取平台和广告参数 上报登录
 * xj_sdk.init()
 * // 播放完激励视频后调用 reportRV 方法上报
 * xj_sdk.reportRV()
 * 
 * @example
 * xj_sdk.init({
 *     success: () => {
 *         console.log('xj_sdk init success')
 *         showRV()
 *     },
 *     fail: () => {
 *         console.log('xj_sdk init fail')
 *     },
 * })
 * 
 * function showRV() {
 *     const videoAd = tt.createRewardedVideoAd({
 *         adUnitId: '5fbhdkjn36iprhef26',
 *     });
 * 
 *     videoAd.onLoad(() => {
 *         console.log('加载完成');
 *         videoAd
 *             .show()
 *             .then(() => {
 *                 console.log('广告显示成功');
 *             })
 *             .catch((err) => {
 *                 console.log('广告组件出现问题', err);
 *             });
 *     });
 *     videoAd.onClose((res) => {
 *         console.log('广告关闭');
 * 
 *         if (res.isEnded) {
 *             console.log('广告播放完');
 *             onShowRV()
 *         } else {
 *             console.log('广告未播放完');
 *         }
 *     })
 *     videoAd.load();
 * }
 * 
 * function onShowRV() {
 *     xj_sdk.reportRV({
 *         success: () => {
 *             console.log('xj_sdk reportRV success')
 *         },
 *         fail: () => {
 *             console.log('xj_sdk reportRV fail')
 *         },
 *     })
 * }
 */

export class xj_sdk {

    /** 应用程序id: launchOptions.extra.appId */
    private static appId = ''

    /**
     * 信息流广告点击id: launchOptions.query.clickid
     * @example
     * clickId = 'B.y3E9djpCKtIpXMEp1MfvvLXgrQUXAiYm79dtMPcGxuUf0tIA0t1VeHc3ww5tqeDClMZHENnN2TbeYpAYJDDlFWxY1H91E1eJTE6OJT5qapReZCBHbfwfjuJcZss2DOWIzC'
     */
    private static clickId = 'y3E9djpCKtIpXMEp1MfvvLXgrQUXAiYm79dtMPcGxuUf0tIA0t1VeHc3ww5tqeDClMZHENnN2TbeYpAYJDDlFWxY1H91E1eJTE6OJT5qapReZCBHbfwfjuJcZss2DOWIzC'

    /**
     * 广告id: launchOptions.query.advertiser_id
     * @example
     * advertiserId = '1768488667248647'
     */
    private static advertiserId = ''

    /** 成功登录SDK服务器后返回 */
    private static openId = ''

    /**
     * sdk初始化方法
     */
    public static init(initOptions?: CallbackOptions) {
        this.log('将 SdkCfg.DEBUG 设置为 false 可以关闭 log')
        this.log('sdk start init')

        const launchOptions = tt.getLaunchOptionsSync()
        this.log('tt launchOptions', launchOptions)

        this.appId = launchOptions.extra.appId
        this.clickId = launchOptions.query.clickid
        this.advertiserId = launchOptions.query.advertiser_id


        this.log('===== this.clickId = ' + this.clickId);

        // FIXME 使用测试id测试
        // this.clickId = 'B.y3E9djpCKtIpXMEp1MfvvLXgrQUXAiYm79dtMPcGxuUf0tIA0t1VeHc3ww5tqeDClMZHENnN2TbeYpAYJDDlFWxY1H91E1eJTE6OJT5qapReZCBHbfwfjuJcZss2DOWIzC'
        // this.advertiserId = '1768488667248647'

        this.getStorageClickId(() => {
            this.getStorageAdId(() => {
                this.getOpenId(initOptions)
            })
        })
    }

    /**
     * 上报播放视频广告
     */
    public static reportRV(reportOptions?: CallbackOptions) {
        if (!this.clickId) {
            this.logError("reportRV without clickId")
            return
        }

        if (!this.openId) {
            this.init({
                success: () => {
                    this.reportRV(reportOptions)
                }
            })
            return
        }

        const body: XJReportRVPostReq = {
            appid: this.appId,
            adid: this.advertiserId,
            openid: this.openId
        }
        this.post({
            apiPath: APIPath.REPORT_REWARD_VIDEO,
            body,
            success: (res: XJReportRVPostRsp) => {
                if (res.data.result === 'succ') {
                    this.log('report reward video success')
                    reportOptions?.success?.()
                } else {
                    this.logError(`report reward video fail errmsg: ${res.data.errmsg}`)
                    reportOptions?.fail?.()
                }
            },
            fail: (res: PostFailRes) => {
                const errMsg = res.errMsg.toLocaleLowerCase()
                if (errMsg.includes("time out") || errMsg.includes("timeout")) {
                    this.reportRV(reportOptions)
                    return
                }
                reportOptions?.fail?.()
            }
        })
    }

    /**
     * 获取储存的 clickId
     * 如果与当前的 clickId 不相同则更新
     */
    private static getStorageClickId(next?: () => void) {
        tt.getStorage({
            key: 'clickId',
            success: (res: { data: string }) => {
                this.log(`getStorage clickId ok, clickId:${res.data}.`)

                // 储存的跟新获取到的相同
                if (res.data === this.clickId) {
                    next?.()
                    return
                }

                // 没有新获取到，使用储存的
                if (!this.clickId) {
                    this.clickId = res.data
                    next?.()
                    return
                }

                // 更新储存
                this.setStorageClickId()
                this.removeStorageOpenId(next)
            },
            fail: (res: TTCallbackRes) => {
                this.logError(`getStorage clickId fail: ${res.errMsg}`)
                if (this.clickId) {
                    this.setStorageClickId()
                }
                next?.()
            }
        })
    }

    private static setStorageClickId() {
        tt.setStorage({
            key: 'clickId',
            data: this.clickId,
            success: () => {
                this.log('setStorage clickId ok')
            },
            fail: (res: TTCallbackRes) => {
                this.logError(`setStorage clickId fail: ${res.errMsg}`)
            }
        })
    }

    private static getStorageAdId(next?: () => void) {
        tt.getStorage({
            key: 'adId',
            success: (res: { data: string }) => {
                this.log(`getStorage adId ok, adId:${res.data}.`)

                // 储存的跟新获取到的相同
                if (res.data === this.advertiserId) {
                    next?.()
                    return
                }

                // 没有新获取到，使用储存的
                if (!this.advertiserId) {
                    this.advertiserId = res.data
                    next?.()
                    return
                }

                // 更新储存
                this.setStorageAdId()
                this.removeStorageOpenId(next)
            },
            fail: (res: TTCallbackRes) => {
                this.logError(`getStorage adId fail: ${res.errMsg}`)
                if (this.advertiserId) {
                    this.setStorageAdId()
                }
                next?.()
            }
        })
    }

    private static setStorageAdId() {
        tt.setStorage({
            key: 'adId',
            data: this.advertiserId,
            success: () => {
                this.log('setStorage adId ok')
            },
            fail: (res: TTCallbackRes) => {
                this.logError(`setStorage adId fail: ${res.errMsg}`)
            }
        })
    }

    /**
     * 获取储存的 openId
     * 如果获取不到则请求登录接口
     */
    private static getOpenId(initOptions?: CallbackOptions) {
        tt.getStorage({
            key: 'openId',
            success: (res: { data: string }) => {
                this.log(`getStorage openId ok, openId:${res.data}.`)
                if (res.data) {
                    this.openId = res.data
                    initOptions?.success?.()
                } else {
                    this.loginTT(initOptions)
                }
            },
            fail: (res: TTCallbackRes) => {
                this.logError(`getStorage openId fail: ${res.errMsg}`)
                this.loginTT(initOptions)
            }
        })
    }

    private static setStorageOpenId() {
        tt.setStorage({
            key: 'openId',
            data: this.openId,
            success: () => {
                this.log('setStorage openId ok')
            },
            fail: (res: TTCallbackRes) => {
                this.logError(`setStorage openId fail: ${res.errMsg}`)
            }
        })
    }

    private static removeStorageOpenId(next?: () => void) {
        tt.removeStorage({
            key: 'openId',
            success: () => {
                this.log('removeStorage openId ok')
            },
            fail: (res: TTCallbackRes) => {
                this.logError(`removeStorage openId fail: ${res.errMsg}`)
            },
            complete: next
        })
    }

    private static loginTT(initOptions?: CallbackOptions) {
        const loginOptions: TTLoginOptions = {
            force: true,
            success: (res: TTLoginSuccessRes) => {
                this.log('loginTT success', res)
                this.loginSdk(res, initOptions)
            },
            /** 接口调用失败的回调函数*/
            fail: (res: TTCallbackRes) => {
                this.logError(`loginTT fail: ${res.errMsg}`)
                initOptions?.fail?.()
            }
        }
        tt.login(loginOptions)
    }

    private static loginSdk(ttLoginRes: TTLoginSuccessRes, initOptions?: CallbackOptions) {
        const body: XJLoginPostReq = {
            appid: this.appId,
            clickid: this.clickId,
            adid: this.advertiserId,
            code: ttLoginRes.code,
            anonymous_code: ttLoginRes.anonymousCode
        }
        this.post({
            apiPath: APIPath.LOGIN,
            body,
            success: (res: XJLoginPostRsp) => {
                if (res.data.openid) {
                    this.openId = res.data.openid
                    this.log(`login success openid: ${res.data.openid}`)
                    initOptions?.success?.()
                    this.setStorageOpenId()
                } else {
                    this.logError(`login fail errmsg: ${res.data.errmsg}`)
                    initOptions?.fail?.()
                }
            },
            fail: (res: PostFailRes) => {
                const errMsg = res.errMsg.toLocaleLowerCase()
                if (errMsg.includes("time out") || errMsg.includes("timeout")) {
                    this.loginSdk(ttLoginRes, initOptions)
                    return
                }
                initOptions?.fail?.()
            }
        })
    }

    /** 发送 post 请求 */
    private static post(params: PostOptions) {
        tt.request({
            url: SdkCfg.SERVER_ADDRESS + params.apiPath,
            method: 'POST',
            data: params.body,
            success: (res: TTRequestSuccessRes) => {
                this.log(`post ${params.apiPath} success: ${JSON.stringify(res)}`)
                if (res.statusCode >= 200 && res.statusCode < 400) {
                    params.success?.(res.data)
                } else {
                    this.logError(`post ${params.apiPath} fail status: ${res.statusCode}`)
                    params.fail?.({ errMsg: `http status code ${res.statusCode}` })
                }
            },
            fail: (res: TTCallbackRes) => {
                this.logError(`post ${params.apiPath} fail: ${res.errMsg}`)
                params.fail?.(res)
            },
        })

        this.log(`post: ${SdkCfg.SERVER_ADDRESS + params.apiPath} params: ${JSON.stringify(params.body)}`)
    }

    /**
     * sdkCfg 的 debug 为 true 时会输出 log
     * @param data 
     */
    private static log(...data: any[]): void {
        if (SdkCfg.DEBUG) {
            console.log('[xj sdk]', ...data)
        }
    }

    private static logError(...data: any[]): void {
        console.error('[xj sdk]', ...data)
    }
}
